import { Modal } from 'react-bootstrap';
import { IOpoCase } from '@nkr/models/opo-case';
import { OpoModalButtons } from '../landing-page/opo-styles';

interface IProps {
    opoCase: IOpoCase | null,
    onConfirm: () => void,
    onCancel: () => void
}

const CaseDeleteModal = ({ opoCase, onConfirm, onCancel }: IProps) => (
    <Modal show={opoCase != null} onHide={onCancel}>
        <Modal.Header closeButton>
            <Modal.Title>Delete Case</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Are you sure you want to delete case <strong>{opoCase?.caseNumber}</strong>{opoCase?.unosId ? <> (UNOS ID {opoCase.unosId})</> : null}? It will be removed from the case list.
        </Modal.Body>
        <Modal.Footer>
            <OpoModalButtons>
                <button type='button' className='btn btn-danger' onClick={onConfirm}>Delete Case</button>
                <button type='button' className='btn' onClick={onCancel}>Cancel</button>
            </OpoModalButtons>
        </Modal.Footer>
    </Modal>
);

export default CaseDeleteModal;
